import React from "react";
import { Helmet } from "react-helmet";
import configs from "../../config/envConfig";

const useHeapAnalytics = () => {
  const HeapComponent = () => {
    return (
      <Helmet>
        <script>
          {`window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};   
heap.load("${configs.HEAP_TRACKING_ID}"); `}
        </script>
      </Helmet>
    );
  };

  const sendHeapEvent = async (evtName, evtVal) => {
    if (process.env.NODE_ENV === "development") {
      //disable tracking in dev
      return;
    }
    window.heap.track(evtName, evtVal);
  };

  return [HeapComponent, sendHeapEvent];
};

export default useHeapAnalytics;
